import ua from '@tencent/docs-user-agent';

// 宿主环境是独立的 app: 文档客户端 | 企微 | 会议 | 融合会议 | 会议 rooms
// 就不需要再与文档客户端交互了
const isInApp = ua.isElectronTencentDocsClient || ua.isWxWork || ua.isTencentMeeting
    || ua.isWxWorkTencentMeeting || ua.isTencentMeetingRooms;

export const shouldInitTencentDocsAppService = ua.isPC && !isInApp;
